import { create } from 'zustand'

export type TimeFilterView = 'graph' | 'map'

export interface TimeRange {
  start: number
  end: number
}

interface TimeFilterState {
  /**
   * View-scoped filters. `null` = no filter for that view (show everything).
   * Stored as numeric ms for cheap comparisons; views format as needed.
   *
   * Timeline is intentionally absent here — it already owns its own filter
   * window inside `timeline-store.ts` (with playback semantics on top).
   */
  graph: TimeRange | null
  map: TimeRange | null

  setFilter: (view: TimeFilterView, range: TimeRange | null) => void
  clear: (view: TimeFilterView) => void
  clearAll: () => void
}

export const useTimeFilterStore = create<TimeFilterState>(set => ({
  graph: null,
  map: null,
  setFilter: (view, range) => set({ [view]: range } as Pick<TimeFilterState, TimeFilterView>),
  clear: view => set({ [view]: null } as Pick<TimeFilterState, TimeFilterView>),
  clearAll: () => set({ graph: null, map: null }),
}))
